import { BaseService } from './base.service'
import { Uris } from '../common/constants'
import { IDocumentParamter, IDocumentListingViewmodel, IDocumentTypeListingViewmodel, IDocumentModel } from '../models/documents'
import { IDocument, DocumentDto } from '../models/documents/document'

export interface IDocumentService {
  getDocuments(blockId: string, param: IDocumentParamter): Promise<IDocumentListingViewmodel[]>;
  downloadDocuments(param: any): Promise<any>;
  getDocumentTypes(): Promise<IDocumentTypeListingViewmodel[]>;
  getAttachmentTypes(id?: any): Promise<any>;
  getDocumentAttachments(param: any): Promise<any>;
  getDocById(id: string): Promise<any>;
  recordDocument(blockId: string, files: IDocumentModel[]): Promise<any>;
  removeDocument(id: string): Promise<any>;
  deleteDocument(id: number): Promise<any>;
  initDocument(opts?: IDocument): DocumentDto;
  saveDocument(document: IDocument): Promise<any>;
  updateDocument(document: IDocument): Promise<any>;
  cookDocument(document:IDocument): any;
  saveTicketDocument(ticketId: string, channelId: string, document: IDocument)
}
export class DocumentService extends BaseService implements IDocumentService {
  getDocuments (blockId: string, param: IDocumentParamter): Promise<IDocumentListingViewmodel[]> {
    return super.get(Uris.BlockDocuments.replace(':id', blockId), param)
      .then((res: any) => {
        return res.data
      })
      .catch(err => err)
  }
  downloadDocuments(param: IDocumentParamter): Promise<any>{
    return super.get(Uris.DownloadDocument, param) //
    .then((res: any) => {
      return res
    })
    .catch(err => err)
  }

  getDocumentTypes (): Promise<IDocumentTypeListingViewmodel[]> {
    return super.get(Uris.DocumentTypes)
      .then((res: any) => {
        return res
      })
      .catch(err => err)
  }
  getAttachmentTypes (id = null) {
    let url = Uris.AttachmentTypes
    if (id) url += '/' + id
    return super.get(url)
  }
  getDocById (id) {
    return super.get(Uris.DocumentById.replace(':id', id))
  }

  getDocumentAttachments (params: any) : Promise<any> {
    return super.get(Uris.DocumentTypes, params)
         .then((response: any) => { console.log('attachments respons', response); return response })
         .catch(err => err)
  }
  recordDocument (blockId: string, files: IDocumentModel[]): Promise<any> {
    const data = {
      files: files.map(x => ({
        file: x.file.result,
        type: x.type,
        name: x.name,
        fk_attachment_type: x.fk_attachment_type
      }))
    }
    return super.post(Uris.BlockDocuments.replace(':id', blockId), data)
  }
  removeDocument (id: string) {
    return super.delete(Uris.Media.replace(':id', id))
      .then(res => res)
      .catch(err => err)
  }
  deleteDocument (id: number) {
    return super.delete(Uris.DocumentManageId.replace(':id', id.toString()))
  }
  initDocument (opts?: IDocument) {
    return new DocumentDto(opts)
  }
  saveDocument (document: IDocument) {
    return this.cookDocument(document)
                  .then(cookedDocument => {
                    return super.post(Uris.DocumentManage, { ...cookedDocument })
                                   .then(response => Promise.resolve(response))
                                   .catch(err => Promise.reject(err))
                  })
  }
  updateDocument (document:IDocument) {
    return this.cookDocument(document, 'update')
                  .then(cookedDocument => {
                    return super.patch(Uris.DocumentManageId.replace(':id', document.id.toString()), {...cookedDocument})
                                     .then(response => Promise.resolve(response))
                                     .catch(err => Promise.reject(err))
                  })
  }
  saveTicketDocument(ticketId, channelId, document){
    return this.cookDocument(document)
                  .then(cookedDocument=>{
                      return super.post(Uris.TicketSendAttachment
                          .replace(':id', ticketId)
                          .replace(':cid', channelId)
                        ,{ ...cookedDocument })
                                   .then(response=> Promise.resolve(response))
                                   .catch(err=> Promise.reject(err))
                  })

  }
  cookDocument (document:IDocument, action:string='create') {
    const { attachments, blocks, apartments, entities, share, equipments, all_block, sharing_role } = document
    let cookedDocument:any = {
      sharing_type: share,
      blocks,
      apartments,
      entities,
      equipments,
      all_block,
      sharing_role
    }
    if (action === 'create') {
      cookedDocument = {
        ...cookedDocument,
        files: attachments.map((attachment:any) => ({
          fk_attachment_type: document.type,
          fk_attachment_type_level_2: document.typeLvl2,
          ...attachment
        }))
      }
    } else {
      cookedDocument = {
        ...cookedDocument,
        name: attachments[0].name,
        fk_attachment_type: parseInt(document.type.toString()),
        fk_attachment_type_level_2: document.typeLvl2,
        reference: attachments[0].reference || null
      }
      if (attachments[0].attributes.length) cookedDocument.attributes = attachments[0].attributes.filter(x => x.value !== null)
    }

    return Promise.resolve(cookedDocument)
  }
}



// WEBPACK FOOTER //
// ./src/services/document.service.ts